import React, { useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import DOMPurify from "dompurify";
import Logo from "../../../assets/img/logos/HBlogotipo.svg";
import { useMaintenanceBanner } from "../../../hooks/useMaintenanceBanner";
import { UserGlobalContextMemorySpace } from "../../../contexts/user/userGlobalContext";
import "./style.scss";

export const MaintenanceModal = () => {
  const { user } = useContext(UserGlobalContextMemorySpace);
  const { banner, visible, dismiss } = useMaintenanceBanner();

  if (!user?.user?.data || !banner || !visible) {
    return null;
  }

  const sanitizedContent = DOMPurify.sanitize(banner.contenido || "", {
    USE_PROFILES: { html: true },
  });

  return (
    <Modal
      show={visible}
      centered
      backdrop="static"
      keyboard={false}
      className="maintenance-modal"
      dialogClassName="maintenance-modal-dialog"
      backdropClassName="maintenance-modal-backdrop"
      onHide={dismiss}
    >
      <Modal.Body className="maintenance-modal-body">
        <img
          src={Logo}
          alt="Hospital Británico"
          className="maintenance-modal-logo"
        />
        <h2 className="maintenance-modal-title">{banner.titulo}</h2>
        <div className="maintenance-modal-content-scroll">
          <div
            className="maintenance-modal-content"
            dangerouslySetInnerHTML={{ __html: sanitizedContent }}
          />
        </div>
        <Button
          type="button"
          className="maintenance-modal-continue"
          onClick={dismiss}
        >
          Continuar
        </Button>
      </Modal.Body>
    </Modal>
  );
};
